import type { AuditFilters } from './audit.types';

/** Admin audit trail (gateway-cloud) — cloud-mode + admin only. */
export const auditEndpoints = {
  list: (f: AuditFilters, limit: number, cursor?: string) => {
    const q = new URLSearchParams();
    if (f.from) q.set('from', f.from);
    if (f.to) q.set('to', f.to);
    if (f.actor) q.set('actor', f.actor);
    if (f.site) q.set('site', f.site);
    if (f.action) q.set('action', f.action);
    if (f.search) q.set('search', f.search);
    if (f.actor) q.set('actor', f.actor);
    if (f.result) q.set('result', f.result);
    q.set('limit', String(limit));
    if (cursor) q.set('cursor', cursor);
    return `/users/v1/admin/audit?${q.toString()}`;
  },
} as const;
